/**
 * Application constants
 */

export const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const RATING_EMOJIS = {
  1: { emoji: '🚫', label: 'Do Not Go' },
  2: { emoji: '😕', label: "Didn't Enjoy" },
  3: { emoji: '😐', label: 'Neutral' },
  4: { emoji: '😊', label: 'Enjoyed' },
  5: { emoji: '😍', label: 'Highly Enjoyed' },
  6: { emoji: '🤩', label: 'Must Go' }
};

export const VIEWS = {
  LOGIN: 'login',
  FEED: 'feed',
  DISCOVER: 'discover',
  PROFILE: 'profile',
  CREATE_REVIEW: 'createReview',
  CREATOR_PROFILE: 'creatorProfile',
  SAVED: 'saved',
  SUBSCRIPTIONS: 'subscriptions'
};
